import React from "react";
import cx from "classnames";
import "./Story.scss";
import { PersonalSecurity } from "../icons/PersonalSecurity";
export const StoryFooter = ({ className = "", contactInfoText, privacyPolicyText, }) => {
    const classNames = cx("lysa-story-footer", className);
    if (!contactInfoText && !privacyPolicyText) {
        return null;
    }
    return (React.createElement("footer", { className: classNames },
        React.createElement("hr", null),
        contactInfoText && React.createElement("address", null, contactInfoText),
        privacyPolicyText && (React.createElement("div", { className: "lysa-story-footer--privacy-policy" },
            React.createElement(PersonalSecurity, { primaryColor: "var(--lysa-text-secondary)" }),
            " ",
            privacyPolicyText))));
};
